import Vue from "vue";
import api from "../../../services/api";
import mapPlanner from "./map.vue";
import draggable from "vuedraggable";
import { bus } from "../../../main";

export default {
	components: {
		mapPlanner,
		draggable
	},

	data: function() {
		return {
			loading: false,
			showTravelDetailsContainer: false,
			showDeletePoint: [false, false],
			points: [
				{
					id: "",
					value: ""
				},
				{
					id: "",
					value: ""
				}
			],

			showRouteOptions: true,
			fastestRoute: false,
			shortestRoute: true,
			avoidHighways: false,
			avoidTolls: false,

			routes: [],

			//Modal selection Recipients for mail
			showModalRecipients: false,
			recipientsSendMail: "",
			recipientsSendMailError: false,
			subjectSendMail: "",
			subjectSendMailError: false,
			sendMailAction: null
		};
	},

	created() {},

	watch: {
		fastestRoute(newValue) {
			if (newValue) this.shortestRoute = false;
		},
		shortestRoute(newValue) {
			if (newValue) this.fastestRoute = false;
		}
	},

	methods: {
		printRoute(route) {
			var self = this;
			var data = {
				summary: route
			};
			api.plannerPrint(data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || "percorso.pdf");
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		sendRoute(route) {
			this.showModalRecipients = true;

			var self = this;

			var sendMailAction = function() {
				var recipients = self.recipientsSendMail;
				var subject = self.subjectSendMail;
				var data = {
					recipients: recipients,
					subject: subject,
					summary: route
				};

				api.plannerSendMail(data).then(res => {
					self.undoDeletePoiAction();
				});
			};

			this.sendMailAction = function() {
				if (self.recipientsSendMail.length == 0) {
					self.recipientsSendMailError = true;
					return false;
				}
				self.recipientsSendMailError = false;

				if (self.subjectSendMail.length == 0) {
					self.subjectSendMailError = true;
					return false;
				}

				self.subjectSendMailError = false;
				sendMailAction();
			};
		},
		undoDeletePoiAction() {
			this.showModalRecipients = false;
			this.recipientsSendMail = "";
			self.subjectSendMail = "";
			this.sendMailAction = null;
			this.recipientsSendMailError = false;
			self.subjectSendMailError = false;
		},
		onShowChangePointDelete(index, value) {
			if (this.points.length > 2) this.$set(this.showDeletePoint, index, value);
		},
		deletePoint(index) {
			if (this.points.length > 2) {
				this.points.splice(index, 1);
				this.showDeletePoint.splice(index, 1);
			}
		},
		addIntermediatePoint() {
			this.showDeletePoint.splice(this.showDeletePoint.length, 0, false);
			this.points.splice(this.points.length - 1, 0, {
				id: "",
				value: ""
			});
		},
		switchStartAndEndPoint(index) {
			this.points.reverse();
		},
		onPlaceInputChange(point, value) {
			point.value = value;
			point.id = "";
		},
		setPlace(place, point) {
			if (!place) return;

			point.id = place.place_id;
			point.value = place.formatted_address || place.name;
		},
		showHideTravelOption() {
			this.showRouteOptions = !this.showRouteOptions;
		},
		calculateRoute() {
			this.showTravelDetailsContainer = false;
			var self = this;
			var pointLength = this.points.length - 1;
			if (this.points.length >= 2 && this.points[0].value && this.points[pointLength].value) {
				var params = {
					origin: this.points[0].value,
					destination: this.points[pointLength].value,
					withAlternatives: true,
					opt: []
				};
				var avoid = [];
				if (this.avoidHighways) avoid.push("highways");
				if (this.avoidTolls) avoid.push("tolls");

				if (avoid.length > 0) params.avoid = avoid;

				if (this.points.length > 2) {
					var intermediatePoints = [];
					for (var i = 1; i < this.points.length - 1; i++) {
						var p = this.points[i];
						if (p) intermediatePoints.push(p.value);
					}

					params.waypoints = intermediatePoints;
				}

				//only for develop
				// if (this.$store.state.data) {
				// 	var res = JSON.parse(this.$store.state.data);
				// 	self.routes = res.routes;

				// 	self.routes.forEach(r => {
				// 		Vue.set(r, "showDetail", false);
				// 	});

				// 	self.$nextTick(function() {
				// 		self.showTravelDetailsContainer = true;
				// 		self.$refs.plannerMap.displayPath();
				// 	});
				// } else {
				bus.$emit("show-spinner-loading");
				api.getPlannerData(params).then(res => {
					self.routes = res.routes;
					self.showTravelDetailsContainer = true;
					self.routes.forEach(r => {
						Vue.set(r, "showDetail", false);
					});
					self.$nextTick(function() {
						self.$refs.plannerMap.displayPath();
					});
				}).finally(() => {
					bus.$emit("hide-spinner-loading");
				});;
				//}
			} else {
			}
		},
		getStepDetail(duration, distance) {
			var distanceStr = "";
			var durationStr = "";

			var dKm = distance / 1000;
			if (distance > 100000) {
				distanceStr = `${parseInt(dKm).toString()} km`;
			} else if (distance < 1000) {
				distanceStr = `${parseInt(distance)} m`;
			} else {
				distanceStr = `${kendo.toString(dKm, "n2")} km`;
			}

			if (duration > 60) {
				durationStr = this.$options.filters.timeFromSecondsToStringHorM(duration);

				return `${durationStr} (${distanceStr})`;
			}

			return `${distanceStr}`;
		},
		getTotalLegDuration(route) {
			var duration = 0;
			route.legs.forEach(leg => {
				duration += leg.duration.value;
			});

			if (duration < 60) return "";

			return this.$options.filters.timeFromSecondsToStringFriendly(duration);
		},
		getTotalLegDistance(route) {
			var distance = 0;
			route.legs.forEach(leg => {
				distance += leg.distance.value;
			});

			var dKm = distance / 1000;
			if (distance > 100000) {
				return `${parseInt(dKm).toString()} km`;
			} else if (distance < 1000) {
				return `${parseInt(distance)} m`;
			}
			return `${dKm.toFixed(2)} km`;
		},
		showDetailByRoute(route, index) {
			route.showDetail = !route.showDetail;
			bus.$emit("on-detail-route-show", index);
		},
		getAllStepsFromRoute(route) {
			var steps = [];
			route.legs.forEach(leg => {
				leg.steps.forEach(step => {
					steps.push(step);
				});
			});

			return steps;
		},
		onCollapseHidden(route) {
			route.showDetail = false;
		}
	},

	computed: {
		mapClass: function() {
			if (this.showHorizontalTable) {
				return "mapwithHorizontalTable";
			}

			return " mapNoTables";
		}
	}
};
